export function getLocalizedValue(
  field: Record<string, string> | string,
  locale: string,
  fallback = 'en'
): string {
  if (typeof field === 'string') return field;
  return field[locale] ?? field[fallback] ?? Object.values(field)[0] ?? '';
}
